import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Case } from '../beans/Case';
import { TaskFrx } from '../beans/TaskFrx';
import { urlLinks } from '../utility/url-links';
import { HttpService } from './http.service';

@Injectable()
export class TaskService {

	constructor(private http: HttpService) {
	}

	changeStatus(taskId: number, isUpgrade: boolean): Observable<any> {
		return this.http.post<any>(
			urlLinks.rest.task.changeStatusTask + '?isUpgrade=' + isUpgrade,
			taskId
		);
	}

	addTask(taskObj: TaskFrx, lawsuitId: number, isNakazatelen: boolean): Observable<any> {
		taskObj.lawsuiteId = lawsuitId;
		return this.http.post<any>(
			urlLinks.rest.task.addTask + '?isNakazatelno=' + isNakazatelen,
			taskObj
		);
	}

	getTasks(lawsuitId: number, isNakazatelen: boolean): Observable<TaskFrx[]> {
		return this.http.get<TaskFrx[]>(
			urlLinks.rest.task.getTasks + '?lawsuiteId=' + lawsuitId + '&isNakazatelno=' + isNakazatelen
		);
	}

	getTasksByUser(): Observable<TaskFrx[]> {
		return this.http.get<TaskFrx[]>(urlLinks.rest.task.getTasksByUser);
	}

	deleteTask(taskId: number): Observable<any> {
		return this.http.delete<any>(
			urlLinks.rest.task.deleteTask + taskId
		);
	}
}
